import Rollbar from 'rollbar/replay';
//49d3380c688f4f4eaab7179d7ed6ba59 DEV 
export default new Rollbar({
    accessToken: '6f111828ac274888bcbe73d28bc940db',
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
        environment: process.env.NODE_ENV || 'development', //'dev',
        client: {
            javascript: {
                code_version: '1.0.0',
            },
        },
    },
    replay: {
        enabled: true,
    }
});
 
 